import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { StockAdjustmentLine, StockAdjustmentLineCreate, StockAdjustmentLineFilter } from '../data/stockAdjustmentLine';

export function createStockAdjustmentLineService(client: AxiosInstance) {
  return createCrudService<StockAdjustmentLine, StockAdjustmentLineCreate, StockAdjustmentLineFilter>(
    client,
    '/purchase/StockAdjustmentLine',
    'id',
  );
}

export type StockAdjustmentLineService = CrudService<StockAdjustmentLine, StockAdjustmentLineCreate, StockAdjustmentLineFilter>;
